import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

/**
 * Named for upload because that is what it first gated. It now covers uploading, removing and
 * previewing, which all arrived together, so the feature goes out as one. Thumbnails predate
 * it and stay listed either way.
 */
export const ATTACHMENTS_FEATURE_FLAG = 'enable-yard-tasks-attachment-upload';

/** Whether attachments are available at all. Everything about them hangs off this. */
export function useAttachmentsFeature() {
  const flag = useFlag(ATTACHMENTS_FEATURE_FLAG);

  return {
    areAttachmentsEnabled: computed(() => Boolean(flag.value?.enabled))
  };
}
